export default "__VITE_ASSET__a893d121__"